// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"4189774a","125":"503d54fc","1308":"12f30fb2","5096":"185592d9","5611":"7423d555","7678":"b096f273","8675":"d2387fd8"}[chunkId] + ".chunk.js";
};